import type { DashboardContext } from './dashboard.js';
import { HELP_SHEETS } from '../generated/help-content.js';

// Zentrale Bedienungsanleitung für den Gambio-Verkaufskanal.
// Inhalt kommt AUSSCHLIESSLICH aus den Direkthilfe-Markdown-Dateien
// (docs/anwenderdoku/gambio/direkthilfe/*.md), zur Build-Zeit generiert in
// ../generated/help-content.ts. Diese Datei rendert nur noch. Kein Netzwerk-Call.

function sectionId(id: string): string {
  return `help-${id}`;
}

function buildToc(): string {
  return HELP_SHEETS.map(
    (s) =>
      `<a class="kl-help-toc-link" href="#${sectionId(s.id)}">` +
      `<span class="v-icon fa-light ${s.icon}" aria-hidden="true"></span>${s.title}</a>`,
  ).join('');
}

function buildSections(): string {
  return HELP_SHEETS.map(
    (s) =>
      `<section id="${sectionId(s.id)}" class="kl-detail-card kl-help-section">` +
      `<h2 class="kl-detail-section-title">` +
      `<span class="v-icon fa-light ${s.icon}" aria-hidden="true"></span> ${s.title}</h2>` +
      `<div class="kl-help-body">${s.html}</div>` +
      `</section>`,
  ).join('');
}

export function renderHelpTab(host: HTMLElement, _ctx: DashboardContext): void {
  host.innerHTML = `
    <div class="kl-help">
      <div class="kl-toolbar"><strong>Anleitung</strong></div>
      <p class="hint">Schritt-für-Schritt-Überblick über die Funktionen der Gambio-Anbindung, von der Einrichtung bis zur Fehlersuche.</p>
      <nav class="kl-help-toc" aria-label="Inhaltsverzeichnis">${buildToc()}</nav>
      ${buildSections()}
    </div>`;
}
